import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 0'
  },
  label: {
    fontSize: '14px',
    color: '#333'
  },
  disabled: {
    opacity: 0.5
  }
}));
